export default function resetAnimation(element?: HTMLElement | null) {
	if (!element) return;
	element.style.animation = 'none';
	element.offsetHeight; /* trigger reflow */
	element.style.animation = '';
}
